// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ypjE","controls":"styles_controls__1LJsW","charLimit":"styles_charLimit__1iXEE","input":"styles_input__3ZILh","send":"styles_send__fPJtb"};